import { useQuery } from "@tanstack/react-query";

import { getReportingKpis } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { REPORTING_QUERY_KEYS } from "./queryKeys";

export function useReportingKpisQuery() {
  return useQuery({
    queryKey: REPORTING_QUERY_KEYS.kpis(),
    queryFn: processResponse(() => getReportingKpis()),
    staleTime: 5 * 60 * 1000,
  });
}
